import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Performance Scorecard entries (BP-23, D-146; BP-10 SRM). One entry per supplier x month x KPI with
 * a 0..100 score and an optional comment — the 30-second quick-entry that makes the scorecard a
 * daily habit. Monthly entry, quarterly roll-up in the view. Shapes shared by the API (validation)
 * and the web app (types).
 */
export const scorecardKpiSchema = z.enum(['otif', 'quality', 'price', 'responsiveness', 'relationship']);
/** 'YYYY-MM' — the scored month (stored as the first day of that month). */
export const scorecardPeriodSchema = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Use the YYYY-MM month format');
export const scorecardEntrySchema = z.object({
    id: uuidSchema,
    supplierId: uuidSchema,
    period: scorecardPeriodSchema,
    kpi: scorecardKpiSchema,
    score: z.number(),
    comment: z.string().nullable(),
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** POST /scorecards/entries — record a score (any member; audited). */
export const createScorecardEntrySchema = z
    .object({
    supplierId: uuidSchema,
    period: scorecardPeriodSchema,
    kpi: scorecardKpiSchema,
    score: z.number().min(0).max(100),
    comment: z.string().trim().max(500).optional(),
})
    .strict();
/** PATCH /scorecards/entries/:id — correct a score or its note. */
export const patchScorecardEntrySchema = z
    .object({
    period: scorecardPeriodSchema.optional(),
    kpi: scorecardKpiSchema.optional(),
    score: z.number().min(0).max(100).optional(),
    comment: z.string().trim().max(500).nullable().optional(),
})
    .strict();
//# sourceMappingURL=scorecards.js.map